// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  // Dashboard
  {
    title: 'Dashboard',
    path: '/admin/',
    icon: icon('ic_home'),
  },
  
  // Core Management
  {
    title: 'Core Management',
    icon: icon('ic_analytics'),
    items: [
      {
        title: 'Users',
        path: '/admin/list-all-users',
        icon: icon('ic_users'),
      },
      {
        title: 'Orders',
        path: '/admin/orders',
        icon: icon('ic_orders'),
      },
      {
        title: 'Packages & Products',
        path: '/admin/packages',
        icon: icon('ic_cart'),
      },
      {
        title: 'Tickets',
        path: '/admin/tickets',
        icon: icon('ic_tickets'),
      },
      {
        title: 'MULAN FCT Week Bookings',
        path: '/admin/mulan-fct-week-bookings',
        icon: icon('ic_analytics'),
      },
      {
        title: 'Bank Accounts',
        path: '/admin/list-all-accounts',
        icon: icon('ic_bank'),
      },
      {
        title: 'Bookkeeping',
        path: '/admin/bookkeeping',
        icon: icon('ic_bookkeeping'),
      },
    ]
  },

  // Business Registration Services
  {
    title: 'Business Registration',
    icon: icon('ic_company'),
    items: [
      {
        title: 'Name Reservation',
        path: '/admin/name-reservation-requests',
        icon: icon('ic_name_reservation'),
      },
      {
        title: 'Business Name Registration',
        path: '/admin/business-registration-applications',
        icon: icon('ic_business_registration'),
      },
      {
        title: 'Company Registration',
        path: '/admin/list-of-companies',
        icon: icon('ic_company'),
      },
    ]
  },

  // Post-Incorporation Services
  {
    title: 'Post-Incorporation',
    icon: icon('ic_post_incorporation'),
    items: [
      {
        title: 'Annual Return',
        path: '/admin/annual-return',
        icon: icon('ic_analytics'),
      },
      {
        title: 'Certified True Copy',
        path: '/admin/certified-true-copy',
        icon: icon('ic_analytics'),
      },
      {
        title: 'Status Report',
        path: '/admin/status-report',
        icon: icon('ic_analytics'),
      },
      {
        title: 'Change of Directors',
        path: '/admin/change-directors',
        icon: icon('ic_user'),
      },
      {
        title: 'Change of Address',
        path: '/admin/change-address',
        icon: icon('ic_user'),
      },
      {
        title: 'Change of Secretary',
        path: '/admin/change-secretary',
        icon: icon('ic_user'),
      },
      {
        title: 'Update Shareholders Details',
        path: '/admin/update-shareholder',
        icon: icon('ic_user'),
      },
      {
        title: 'Update Directors Details',
        path: '/admin/update-directors',
        icon: icon('ic_user'),
      },
    ]
  },

  // Additional Services
  {
    title: 'Additional Services',
    icon: icon('ic_analytics'),
    items: [
      {
        title: 'Trademark',
        path: '/admin/trademark',
        icon: icon('ic_analytics'),
      },
      {
        title: 'TIN Registration',
        path: '/admin/tin',
        icon: icon('ic_analytics'),
      },
      {
        title: 'Business Starter Toolkit',
        path: '/admin/business-starter-toolkit',
        icon: icon('ic_analytics'),
      },
    ]
  },

  // CAC Services
  {
    title: 'CAC Services',
    icon: icon('ic_company'),
    items: [
      {
        title: 'Create Client',
        path: '/admin/cac',
        icon: icon('ic_user'),
      },
      {
        title: 'CAC Business Registration',
        path: '/admin/business-registration-cac',
        icon: icon('ic_company'),
      },
    ]
  }

  // {
  //   title: 'product',
  //   path: '/admin/products',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'blog',
  //   path: '/admin/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
